/* OFUQ — أُفُق | theme.js  (لا مكتبات خارجية) */
(function () {
  'use strict';
  var D = document, W = window;
  var $ = function (s, c) { return (c || D).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || D).querySelectorAll(s)); };
  var on = function (el, ev, fn, o) { el && el.addEventListener(ev, fn, o); };

  /* ذاكرة محلية آمنة (تعمل حتى لو كان التخزين محجوبًا) */
  var mem = {};
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return mem[k] || null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) { mem[k] = v; } }
  };

  var money = function (cents) {
    var s = (W.OFUQ && W.OFUQ.moneyFormat) || '{{amount}} ₪';
    var n = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return s.replace(/\{\{\s*amount\s*\}\}/, n);
  };

  /* ---------- 1. الهيدر + شريط التقدّم ---------- */
  var hdr = $('.hdr'), prog = $('.prog'), lastY = 0;
  function onScroll() {
    var y = W.scrollY || 0;
    if (hdr) hdr.classList.toggle('up', y > 12);
    if (prog) {
      var h = D.documentElement.scrollHeight - W.innerHeight;
      prog.style.width = (h > 0 ? (y / h) * 100 : 0) + '%';
    }
    lastY = y;
  }
  on(W, 'scroll', function () { W.requestAnimationFrame(onScroll); }, { passive: true });
  onScroll();

  /* ---------- 2. الأدراج (قائمة / سلة / بحث) ---------- */
  var veil = $('.veil');
  function openDrw(sel) {
    var d = $(sel); if (!d) return;
    d.classList.add('on'); veil && veil.classList.add('on');
    D.body.style.overflow = 'hidden';
    var f = d.querySelector('input,button,a'); f && f.focus({ preventScroll: true });
  }
  function closeAll() {
    $$('.drw').forEach(function (d) { d.classList.remove('on'); });
    $$('.modal').forEach(function (m) { m.classList.remove('on'); });
    veil && veil.classList.remove('on');
    D.body.style.overflow = '';
  }
  $$('[data-open]').forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); openDrw(b.dataset.open); }); });
  $$('[data-close]').forEach(function (b) { on(b, 'click', closeAll); });
  on(veil, 'click', closeAll);
  on(D, 'keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- 3. الظهور عند التمرير ---------- */
  if ('IntersectionObserver' in W) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    $$('.reveal,.horizon').forEach(function (el) { io.observe(el); });
  } else { $$('.reveal,.horizon').forEach(function (el) { el.classList.add('in'); }); }

  /* ---------- 4. معرض المنتج: تبديل + تكبير + فيديو ---------- */
  function gallery(root) {
    var main = $('.gal__main', root), thumbs = $$('.gal__thumbs button', root);
    if (!main) return;
    var img = $('img', main), vidWrap = $('.gal__video', root), i = 0;
    var dots = $('[data-gal-dots]', root);
    if (dots) {
      dots.innerHTML = thumbs.length > 1 ? thumbs.map(function () { return '<i></i>'; }).join('') : '';
    }
    function show(n) {
      var t = thumbs[n]; if (!t) return;
      i = n;
      thumbs.forEach(function (x) { x.classList.toggle('on', x === t); });
      if (dots) $$('i', dots).forEach(function (d, n2) { d.classList.toggle('on', n2 === n); });
      if (t.dataset.video && vidWrap) {
        vidWrap.classList.remove('hide'); main.classList.add('hide');
        var f = $('video,iframe', vidWrap); if (f && f.tagName === 'VIDEO') { f.play().catch(function () { }); }
        return;
      }
      if (vidWrap) { vidWrap.classList.add('hide'); var v = $('video', vidWrap); v && v.pause(); }
      main.classList.remove('hide');
      var src = t.dataset.src || $('img', t).src, set = t.dataset.srcset || '';
      var pre = new Image();
      pre.onload = function () { img.style.opacity = 0; setTimeout(function () { img.src = src; if (set) img.srcset = set; img.style.opacity = 1; }, 120); };
      pre.src = src;
    }
    thumbs.forEach(function (t, n) { on(t, 'click', function () { show(n); }); });
    $$('[data-gal-prev]', root).forEach(function (b) { on(b, 'click', function () { show((i - 1 + thumbs.length) % thumbs.length); }); });
    $$('[data-gal-next]', root).forEach(function (b) { on(b, 'click', function () { show((i + 1) % thumbs.length); }); });
    root.gallerySync = function (mediaId) {
      var t = thumbs.filter(function (x) { return x.dataset.mid === String(mediaId); })[0];
      if (t) show(thumbs.indexOf(t));
    };
    /* تكبير بالمؤشر — سطح المكتب فقط */
    if (W.matchMedia('(hover:hover)').matches) {
      on(main, 'mousemove', function (e) {
        if (!main.classList.contains('zoomed')) return;
        var r = main.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      on(main, 'click', function () { main.classList.toggle('zoomed'); img.style.transform = ''; });
      on(main, 'mouseleave', function () { main.classList.remove('zoomed'); });
    } else {
      /* سحب أفقي على الجوال */
      var x0 = null;
      on(main, 'touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      on(main, 'touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) show(dx < 0 ? (i + 1) % thumbs.length : (i - 1 + thumbs.length) % thumbs.length);
        x0 = null;
      });
    }
  }
  $$('[data-gallery]').forEach(gallery);

  /* ---------- 5. الكمية ---------- */
  on(D, 'click', function (e) {
    var b = e.target.closest('[data-q]'); if (!b) return;
    var box = b.closest('.qty'), inp = $('input', box);
    var v = parseInt(inp.value, 10) || 1;
    v = Math.max(parseInt(inp.min || 1, 10), v + (b.dataset.q === '+' ? 1 : -1));
    inp.value = v; inp.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- 6. اختيار المتغيّر (variants) ---------- */
  function variants(form) {
    var data = $('[data-variants]', form);
    if (!data) return;
    var list; try { list = JSON.parse(data.textContent); } catch (e) { return; }
    var root = form.closest('[data-product]') || D;
    var idIn = $('[name="id"]', form);
    var groups = $$('[data-opt]', form);
    var priceEls = $$('[data-price]'), cmpEls = $$('[data-compare]'), saveEls = $$('[data-save]');
    var addBtn = $('[data-add]', form), nowBtn = $('[data-now]', form);
    var stockEl = $('[data-stock]', root), sku = $('[data-sku]', root);

    function chosen() {
      return groups.map(function (g) {
        var b = $('[aria-pressed="true"]', g); return b ? b.dataset.val : null;
      });
    }
    function find(sel) {
      return list.filter(function (v) {
        return v.options.every(function (o, n) { return sel[n] == null || o === sel[n]; });
      })[0];
    }
    function paint() {
      var sel = chosen(), v = find(sel);
      /* تعطيل القيم غير المتاحة */
      groups.forEach(function (g, gi) {
        $$('button', g).forEach(function (b) {
          var probe = sel.slice(); probe[gi] = b.dataset.val;
          var m = list.filter(function (x) {
            return x.options.every(function (o, n) { return probe[n] == null || o === probe[n]; });
          });
          b.classList.toggle('out', !m.some(function (x) { return x.available; }));
        });
        var lb = g.previousElementSibling && g.previousElementSibling.querySelector('b');
        var cur = $('[aria-pressed="true"]', g);
        if (lb && cur) lb.textContent = cur.dataset.val;
      });
      if (!v) return;
      if (idIn) idIn.value = v.id;
      priceEls.forEach(function (e) { e.textContent = money(v.price); });
      cmpEls.forEach(function (e) {
        if (v.compare > v.price) { e.textContent = money(v.compare); e.classList.remove('hide'); }
        else e.classList.add('hide');
      });
      saveEls.forEach(function (e) {
        if (v.compare > v.price) {
          e.textContent = 'وفّر ' + Math.round((1 - v.price / v.compare) * 100) + '%';
          e.classList.remove('hide');
        } else e.classList.add('hide');
      });
      if (sku) sku.textContent = v.sku || '';
      if (stockEl) {
        if (v.available && v.qty > 0 && v.qty <= (parseInt(stockEl.dataset.low, 10) || 8)) {
          stockEl.classList.remove('hide');
          var n = $('[data-stock-n]', stockEl); if (n) n.textContent = v.qty;
          var bar = $('.stock__bar i', stockEl);
          if (bar) bar.style.setProperty('--p', Math.max(6, Math.min(100, v.qty * 8)) + '%');
        } else stockEl.classList.add('hide');
      }
      [addBtn, nowBtn].forEach(function (b) {
        if (!b) return;
        b.toggleAttribute('disabled', !v.available);
        if (b === addBtn) $('span', b).textContent = v.available ? (b.dataset.label || 'أضف إلى السلة') : 'نفدت الكمية';
        if (b === nowBtn) b.classList.toggle('hide', !v.available);
      });
      if (v.media && root.gallerySync) root.gallerySync(v.media);
      var gal = $('[data-gallery]', root); if (gal && gal.gallerySync && v.media) gal.gallerySync(v.media);
      if (W.history.replaceState) {
        var u = new URL(W.location); u.searchParams.set('variant', v.id);
        W.history.replaceState({}, '', u);
      }
      D.dispatchEvent(new CustomEvent('ofuq:variant', { detail: v }));
    }
    groups.forEach(function (g) {
      $$('button', g).forEach(function (b) {
        on(b, 'click', function () {
          $$('button', g).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true'); paint();
        });
      });
    });
    paint();
  }
  $$('[data-buy-form]').forEach(variants);

  /* ---------- 7. حزم الكمية ---------- */
  function bundles(form) {
    var box = $('[data-bundles]', form); if (!box) return;
    var qtyIn = $('[name="quantity"]', form);
    $$('input[type="radio"]', box).forEach(function (r) {
      on(r, 'change', function () {
        if (qtyIn) qtyIn.value = r.dataset.qty || 1;
        D.dispatchEvent(new CustomEvent('ofuq:variant', { detail: null }));
      });
    });
    D.addEventListener('ofuq:variant', function () {
      var base = parseInt(box.dataset.base, 10) || 0;
      var cur = $('input:checked', box);
      $$('.bnd', box).forEach(function (el) {
        var q = parseInt(el.dataset.qty, 10) || 1, pct = parseFloat(el.dataset.pct) || 0;
        var full = base * q, net = Math.round(full * (1 - pct / 100));
        var p = $('[data-bnd-p]', el), d = $('[data-bnd-d]', el);
        if (p) p.textContent = money(net);
        if (d) { d.textContent = pct ? money(full) : ''; d.classList.toggle('hide', !pct); }
      });
      if (cur && qtyIn) qtyIn.value = cur.dataset.qty || 1;
    });
  }
  $$('[data-buy-form]').forEach(bundles);

  /* ---------- 8. العدّاد (موعد حقيقي فقط) ---------- */
  $$('[data-deadline]').forEach(function (el) {
    var end = new Date(el.dataset.deadline).getTime();
    if (isNaN(end)) { el.classList.add('hide'); return; }
    var slots = $$('[data-t]', el);
    (function tick() {
      var d = end - Date.now();
      if (d <= 0) { el.classList.add('hide'); return; }
      var s = Math.floor(d / 1000), map = { d: Math.floor(s / 86400), h: Math.floor(s / 3600) % 24, m: Math.floor(s / 60) % 60, s: s % 60 };
      slots.forEach(function (x) {
        var n = map[x.dataset.t];
        $('em', x).textContent = (n < 10 ? '0' : '') + n;
      });
      setTimeout(tick, 1000);
    })();
  });

  /* ---------- 9. زر الشراء الثابت ---------- */
  var sticky = $('.sticky'), anchor = $('[data-atc-anchor]');
  if (sticky && anchor) {
    D.body.classList.add('has-sticky');
    var so = new IntersectionObserver(function (es) {
      sticky.classList.toggle('on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0);
    }, { threshold: 0 });
    so.observe(anchor);
  }

  /* ---------- 10. السلة (AJAX) ---------- */
  function cartCount(n) { $$('[data-cart-count]').forEach(function (e) { e.textContent = n; e.classList.toggle('hide', !n); }); }
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cartCount(c.item_count);
        var bar = $('[data-fsb]');
        if (bar) {
          var goal = parseInt(bar.dataset.goal, 10) || 0, left = goal - c.total_price;
          $('.fsb__bar i', bar).style.setProperty('--p', Math.min(100, goal ? c.total_price / goal * 100 : 100) + '%');
          $('[data-fsb-t]', bar).innerHTML = left > 0
            ? 'أضف <b>' + money(left) + '</b> للحصول على شحن مجاني'
            : 'رائع — طلبك مؤهّل للشحن المجاني';
        }
        D.dispatchEvent(new CustomEvent('ofuq:cart', { detail: c }));
      }).catch(function () { });
  }
  on(D, 'submit', function (e) {
    var f = e.target.closest('[data-buy-form]'); if (!f) return;
    if (e.submitter && e.submitter.dataset.now !== undefined) return; /* اشترِ الآن → checkout */
    e.preventDefault();
    var btn = $('[data-add]', f), lbl = btn ? $('span', btn).textContent : '';
    if (btn) { $('span', btn).textContent = '…'; btn.disabled = true; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(f), headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () { refreshCart(); openDrw('.drw--cart'); })
      .catch(function () { f.submit(); })
      .then(function () { if (btn) { $('span', btn).textContent = lbl; btn.disabled = false; } });
  });
  if ($('[data-cart-count]')) refreshCart();

  /* ---------- 11. المفضلة + المقارنة ---------- */
  function listOf(k) { try { return JSON.parse(store.get(k) || '[]'); } catch (e) { return []; } }
  function saveList(k, a) { store.set(k, JSON.stringify(a)); }

  /* المفضلة: مصفوفة معرّفات */
  function toggleWish(id) {
    var a = listOf('ofuq:wish'), i = a.indexOf(id);
    if (i > -1) a.splice(i, 1); else a.push(id);
    saveList('ofuq:wish', a);
  }

  /* المقارنة: مصفوفة كائنات، بحد أقصى 4 */
  var CMP_MAX = 4;
  function toggleCmp(btn) {
    var a = listOf('ofuq:cmp'), id = btn.dataset.cmp;
    var i = -1;
    a.forEach(function (x, n) { if (x.id === id) i = n; });
    if (i > -1) a.splice(i, 1);
    else {
      if (a.length >= CMP_MAX) { a.shift(); }
      a.push({
        id: id, title: btn.dataset.title || '', price: btn.dataset.price || '',
        img: btn.dataset.img || '', url: btn.dataset.url || '#', meta: btn.dataset.meta || ''
      });
    }
    saveList('ofuq:cmp', a);
  }

  var cmpBar = $('[data-cmpbar]');
  function syncBadges() {
    var w = listOf('ofuq:wish'), c = listOf('ofuq:cmp');
    var cids = c.map(function (x) { return x.id; });
    $$('[data-wish]').forEach(function (b) { b.classList.toggle('on', w.indexOf(b.dataset.wish) > -1); });
    $$('[data-cmp]').forEach(function (b) { b.classList.toggle('on', cids.indexOf(b.dataset.cmp) > -1); });
    $$('[data-wish-count]').forEach(function (e) { e.textContent = w.length; e.classList.toggle('hide', !w.length); });
    if (cmpBar) {
      var list = $('[data-cmp-list]', cmpBar), n = $('[data-cmp-n]', cmpBar);
      if (list) list.innerHTML = c.map(function (x) {
        return '<img src="' + x.img + '" alt="' + x.title + '" title="' + x.title + '">';
      }).join('');
      if (n) n.textContent = c.length;
      cmpBar.classList.toggle('on', c.length > 1);
      D.body.classList.toggle('has-cmp', c.length > 1);
    }
  }
  on(D, 'click', function (e) {
    var w = e.target.closest('[data-wish]');
    if (w) { e.preventDefault(); toggleWish(w.dataset.wish); syncBadges(); return; }
    var c = e.target.closest('[data-cmp]');
    if (c) { e.preventDefault(); toggleCmp(c); syncBadges(); }
  });
  on($('[data-cmp-clear]'), 'click', function () { saveList('ofuq:cmp', []); syncBadges(); });
  on($('[data-cmp-open]'), 'click', function () {
    var c = listOf('ofuq:cmp'), t = $('[data-cmp-table]');
    if (!t || !c.length) return;
    var rows = [
      ['', c.map(function (x) { return '<img src="' + x.img + '" alt="' + x.title + '">'; })],
      ['المنتج', c.map(function (x) { return '<a class="link" href="' + x.url + '">' + x.title + '</a>'; })],
      ['السعر', c.map(function (x) { return '<b>' + x.price + '</b>'; })],
      ['النوع', c.map(function (x) { return x.meta || '—'; })],
      ['', c.map(function (x) { return '<a class="btn btn--sm btn--line" href="' + x.url + '"><span>عرض</span></a>'; })]
    ];
    t.innerHTML = rows.map(function (r) {
      return '<tr><th>' + r[0] + '</th>' + r[1].map(function (cell) { return '<td>' + cell + '</td>'; }).join('') + '</tr>';
    }).join('');
    var m = $('.modal--cmp');
    if (m) { m.classList.add('on'); D.body.style.overflow = 'hidden'; }
  });
  syncBadges();

  /* ---------- 12. العرض السريع ---------- */
  on(D, 'click', function (e) {
    var b = e.target.closest('[data-qv]'); if (!b) return;
    e.preventDefault();
    var m = $('.modal--qv'); if (!m) return;
    var c = $('[data-qv-body]', m);
    c.innerHTML = '<div class="qv"><img src="' + b.dataset.img + '" alt=""><div class="qv__b">' +
      '<h3 class="d3">' + b.dataset.title + '</h3><div class="price mt"><b>' + b.dataset.price + '</b></div>' +
      '<p class="sm">' + (b.dataset.desc || '') + '</p>' +
      '<a class="btn btn--wide mt" href="' + b.dataset.url + '"><span>عرض المنتج</span></a></div></div>';
    m.classList.add('on'); D.body.style.overflow = 'hidden';
  });

  /* ---------- 13. إشعار "تم شراؤه حديثًا" (بيانات حقيقية فقط) ---------- */
  var feed = $('[data-recent]');
  if (feed) {
    var items; try { items = JSON.parse(feed.textContent); } catch (e) { items = []; }
    if (items.length) {
      var t = $('.toast'), n = 0;
      var show = function () {
        var it = items[n % items.length]; n++;
        $('[data-toast-img]', t).src = it.img || '';
        $('[data-toast-t]', t).textContent = it.title;
        $('[data-toast-s]', t).textContent = it.note || '';
        t.classList.add('on');
        setTimeout(function () { t.classList.remove('on'); }, 6000);
        setTimeout(show, 6000 + (18000 + Math.random() * 14000));
      };
      setTimeout(show, 9000);
      on($('.toast__x'), 'click', function () { t.classList.remove('on'); items = []; });
    }
  }

  /* ---------- 14. نية المغادرة (سطح المكتب) + تأخير (جوال) ---------- */
  var exit = $('.modal--exit');
  if (exit && !store.get('ofuq:exit')) {
    var fire = function () {
      if (store.get('ofuq:exit')) return;
      store.set('ofuq:exit', '1');
      exit.classList.add('on'); D.body.style.overflow = 'hidden';
    };
    if (W.matchMedia('(hover:hover)').matches) {
      on(D, 'mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 4) fire(); });
    } else {
      var idle = setTimeout(fire, 45000);
      on(D, 'touchstart', function () { }, { passive: true });
      on(W, 'pagehide', function () { clearTimeout(idle); });
    }
  }

  /* ---------- 15. البحث المباشر ---------- */
  var sInput = $('[data-search-input]');
  if (sInput) {
    var timer, out = $('[data-search-out]');
    on(sInput, 'input', function () {
      clearTimeout(timer);
      var q = sInput.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var ps = (d.resources.results.products || []);
            out.innerHTML = ps.length ? ps.map(function (p) {
              return '<a class="line" href="' + p.url + '" style="grid-template-columns:56px 1fr">' +
                '<img src="' + (p.image || '') + '" alt="" loading="lazy"><div class="line__t"><b>' + p.title + '</b>' +
                '<span>' + (p.price || '') + '</span></div></a>';
            }).join('') : '<p class="sm">لا نتائج لـ "' + q + '"</p>';
          }).catch(function () { });
      }, 240);
    });
  }

  /* ---------- 16. النسخ (كوبون) ---------- */
  on(D, 'click', function (e) {
    var b = e.target.closest('[data-copy]'); if (!b) return;
    var v = b.dataset.copy;
    var done = function () { var o = b.textContent; b.textContent = 'تم النسخ ✓'; setTimeout(function () { b.textContent = o; }, 1800); };
    if (navigator.clipboard) navigator.clipboard.writeText(v).then(done).catch(done); else done();
  });
})();
